<template>
  <v-select
    :value="value"
    v-bind="$attrs"
    :items="projectBookingStatuses"
    item-value="id"
    item-color=""
    @change="onChange"
  >
    <template v-slot:item="{ item }">
      <v-icon :class="item.class" class="mr-2">{{ item.icon }}</v-icon>
      <span :class="item.class">{{ item.name }}</span>
    </template>
    <template v-slot:selection="{ item }">
      <v-icon :class="item.class" class="mr-2">{{ item.icon }}</v-icon>
      <span :class="item.class">{{ item.name }}</span>
    </template>
  </v-select>
</template>


<script>
import projectBookingStatusMixin from '@/mixins/projectBookingStatus.mixin'


export default {
  mixins: [projectBookingStatusMixin],


  props: {
    value: {
      type: Number
    }
  },


  data () {
    return {
      model: null
    }
  },


  methods: {
    onChange (val) {
      this.$emit('input', val)
    }
  }
}
</script>
